class GSTControls extends HTMLElement {
  constructor () {
    super()

    this.gstIncludeButton = this.querySelector('[data-gst-include]')
    this.gstExcludeButton = this.querySelector('[data-gst-exclude]')

    this.defaultState = 'included'

    if (!localStorage.getItem('gst')) localStorage.setItem('gst', this.defaultState)

    this._state = localStorage.getItem('gst') ? localStorage.getItem('gst') : this.defaultState

    this.setupListeners()

    this.updatePrices()
  }

  setupListeners () {
    this.gstInclude = this.gstInclude.bind(this)
    this.gstExclude = this.gstExclude.bind(this)

    this.gstIncludeButton.addEventListener('click', this.gstInclude)
    this.gstExcludeButton.addEventListener('click', this.gstExclude)

    const observerConfig = { attributes: true, childList: true, subtree: true }
    const moneyHandler  = this.BOLDMoneyHandler.bind(this)
    document.querySelectorAll('.money').forEach(money => {
      const moneyObserver = new MutationObserver(moneyHandler)

      moneyObserver.observe(money, observerConfig)
    })

    document.addEventListener('recommendations:loaded', (e) => {
      const container = e.detail.element

      container.querySelectorAll('.money').forEach(money => {
        const recommendationMoneyObserver = new MutationObserver(moneyHandler)
        recommendationMoneyObserver.observe(money, observerConfig)
      })
    })
  }
  
  gstInclude (e) {
    e.preventDefault()
    this.gstToggle('included')
    this.updatePrices()
  }

  gstExclude (e) {
    e.preventDefault()
    this.gstToggle('excluded')
    this.updatePrices()
  }

  gstToggle (state) {
    this.state = state
    localStorage.setItem('gst', state)
  }

  updatePrices() {
    document.querySelector('body').setAttribute('data-gst-included', this._state === 'included')
  }

  BOLDMoneyHandler (mutationList, observer) {
    const target = mutationList[0].target.classList.contains('money') ? mutationList[0].target : mutationList[0].target.querySelector('.money') ? mutationList[0].target.querySelector('.money') : null
    if (!target) return

    if (!target.closest('.price-gst-included')) return

    const priceContainer = target.closest('.price-gst-included')

    const oldValue = Number(target.innerHTML.replace(/[^0-9.-]+/g,""))
    if (Number(priceContainer.dataset.modifiedPrice) === oldValue) return

    const value = Number.parseFloat(oldValue * 1.15).toFixed(2)

    priceContainer.dataset.modifiedPrice = value
    target.innerHTML = `$${value} NZD`
  }

  get state() {
    return this._state
  }
  
  set state(x) {
    this._state = x
    localStorage.setItem('gst', this._state)
  }
}

if (!customElements.get('gst-controls')) {
  customElements.define('gst-controls', GSTControls)
}
